import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { contactQueryParams, WINDOW } from '@inshared/shared/util';
import { AppRoutesEnum } from '@app/routes';

@Component({
    selector: 'ins-contact-question-redirect',
    template: '',
})
export class ContactQuestionRedirectComponent implements OnInit {

    #platformId = inject(PLATFORM_ID);
    #activatedRoute = inject(ActivatedRoute);
    #window = inject(WINDOW);

    ngOnInit() {
        if (isPlatformServer(this.#platformId)) {
            return;
        }

        this.#activatedRoute.paramMap.pipe(take(1)).subscribe(params => {
            this.#window.location.href = contactQueryParams(
                AppRoutesEnum.Question,
                params.get('category_code'),
                params.get('subject_code')
            )
        })
    }
}
